export default "__VITE_ASSET__8j_sdNyO__"